<template>
  <div class="input-with-adder-wrapper">
    <Input
      :forceUpdate="forceUpdate"
      borderRadius="28.5px"
      textAlign="center"
      :value="format && value !== '' ? formatter.format(value) : value"
      @input="onInput"
      :placeholder="placeholder"
      :color="error ? '#e91545' : '#000d28'"
    />
    <span @click="onAdd" class="adder">+ </span>
    <span @click="onSubtract" class="subtractor">- </span>
  </div>
</template>

<script>
import Input from './Input.vue';

export default {
  name: 'InputWithAdder',
  props: {
    value: {
      type: String | Number
    },
    forceUpdate: {
      type: Number
    },
    step: {
      type: Number
    },
    format: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    error: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Input
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      })
    };
  },
  computed: {
    isError() {
      return null;
    }
  },
  methods: {
    parse(value) {
      if (value[0] === '$') {
        value = parseFloat(value.slice(1, value.length).replace(/,/g, ''));
      }
      return Number(value);
    },
    onInput(e) {
      this.$emit('input', this.parse(e.target.value));
    },
    onAdd() {
      this.$emit('count', (this.parse(this.value) || 0) + this.step);
    },
    onSubtract() {
      this.$emit('count', (this.parse(this.value) || 0) - this.step);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-with-adder-wrapper {
  position: relative;

  & .adder {
    position: absolute;
    right: 10px;
    top: 50%;
    cursor: pointer;
    transform: translate(-50%, -50%);
    color: #5b5b5b;
    font-size: 25px;
    font-weight: bold;
    padding: 5px;
  }

  & .subtractor {
    padding: 5px;
    position: absolute;
    top: 50%;
    right: 40px;
    cursor: pointer;
    transform: translate(-50%, -50%);
    color: #5b5b5b;
    font-size: 25px;
    font-weight: bold;
  }
}
</style>
